// Unpublished Work © 2025 Deere & Company.

import {
    commonErrorAction,
    ErrorHandlerConfig,
} from '../App/utils/errorMessages';

export const prescriptionMetaError: ErrorHandlerConfig = {
    customAction: (error, query) => commonErrorAction(error, query),
};

export const rxError: ErrorHandlerConfig = {
    customAction: (error, query) => commonErrorAction(error, query),
};
